import api from "./apiService";


export const login = (data) => api().post(`/admin/login`, data).then(response => response.data);

export const changePassword = (data) => api().post(`/admin/changePassword`, data).then(response => response.data);

const services = {
    login, changePassword
};


export default services;